/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guarantee_Heading_ItalicInputs */

const et_guarantee_heading_italic = /** @type {(inputs: Guarantee_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lihtne`)
};

const en_guarantee_heading_italic = /** @type {(inputs: Guarantee_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`simple`)
};

/**
* | output |
* | --- |
* | "simple" |
*
* @param {Guarantee_Heading_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const guarantee_heading_italic = /** @type {((inputs?: Guarantee_Heading_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guarantee_Heading_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_guarantee_heading_italic(inputs)
	return en_guarantee_heading_italic(inputs)
});